import { render, staticRenderFns } from "./TableChart.vue?vue&type=template&id=47666b0a&scoped=true&"
import script from "./TableChart.vue?vue&type=script&lang=js&"
export * from "./TableChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47666b0a",
  null
  
)

export default component.exports